export default "__VITE_ASSET__C2BiV8Dl__"